import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { IDropdownOption } from "@fluentui/react";
dayjs.extend(customParseFormat);

const dateFormats = {
  default: ["DD-MM-YYYY", "D-M-YYYY", "DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", "YYYY-M-D"],
  enUS: ["MM-DD-YYYY", "M-D-YYYY", "MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD", "YYYY-M-D"]
}

export class DateService {
  static getHours(): IDropdownOption[] {
    let options: IDropdownOption[] = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 30) {
        let ampm = hours < 12 || hours > 23 ? "AM" : "PM";
        options.push({
          key: `${hours}:${minutes == 0 ? "00" : minutes}`,
          text: `${hours}:${minutes == 0 ? "00" : minutes} ${ampm}`
        });
      }
    }

    return options;
  }

  static getTodayString(): string {
    const today = new Date();

    const year = `${today.getFullYear()}`;
    const month = (`0${today.getMonth() + 1}`).slice(-2);
    const day = (`0${today.getDate()}`).slice(-2);

    return `${year}${month}${day}`;
  }

  static parseDateFromString(dateStr: string): Date {
    let dayjsDate: dayjs.Dayjs;
    if (navigator.language === "en-US") {
      dayjsDate = dayjs(dateStr, dateFormats.enUS, true);
    }
    else {
      dayjsDate = dayjs(dateStr, dateFormats.default, true);
    }

    if (dayjsDate.isValid()) {
      return dayjsDate.toDate();
    }

    //if dateStr is DATE ONLY ISO 8601 -> add time so Date.parse() won't convert it to UTC
    //See here: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#date_time_string_format
    if (dateStr.match(/^\d{4}(-\d{2}){2}$/)) {
      dateStr += 'T12:00';
    }
    const date = Date.parse(dateStr);
    return date ? new Date(date) : null;
  }
}
